import LoginForm from "./LoginForm";

export default function LoginPage() {
  return (
    <div
      className="auth-page-wrapper d-flex"
      style={{
        width: "100%",
        minHeight: "90vh",
        alignItems: "center",
        justifyContent: "center",
        padding: "10px",
      }}
    >
      <div
        className="login-container d-flex flex-column flex-md-row"
        style={{
          width: "100%",
          maxWidth: "900px",
          background: "gray",
          borderRadius: "10px",
          overflow: "hidden",
        }}
      >
        {/* Left Image (hidden on mobile) */}
        <div className="login-left d-none d-md-block w-50">
          <img
            src="/login-register-image.png"
            className="w-100 h-100"
            style={{ objectFit: "cover" }}
          />
        </div>

        {/* Right Form */}
        <div className="login-right w-100 w-md-50 d-flex align-items-center justify-content-center p-4">
          <LoginForm onCreateAccount={() => {}} />
        </div>
      </div>
    </div>
  );
}
